module.exports = __webpack_public_path__ + "img/take-off.c832001f.svg";